module.exports = __webpack_public_path__ + "img/icon_sensor_net_1.11069833.svg";